/**
 * Authentication utility functions for managing partner login state
 */

/**
 * Store partner authentication information
 * @param {Object} partnerData - Partner data containing partner_id, partner_name, and optional token
 */
export const storePartnerAuth = (partnerData) => {
  if (partnerData.partner_id) {
    localStorage.setItem('partner_id', partnerData.partner_id);
    localStorage.setItem('isAuthenticated', 'true');
  }
  if (partnerData.partner_name) {
    localStorage.setItem('partner_name', partnerData.partner_name);
  }
  if (partnerData.token) {
    localStorage.setItem('authToken', partnerData.token);
  }
};

/**
 * Get stored partner information
 * @returns {Object} Partner information from localStorage
 */
export const getPartnerAuth = () => {
  return {
    partner_id: localStorage.getItem('partner_id'),
    partner_name: localStorage.getItem('partner_name'),
    authToken: localStorage.getItem('authToken'),
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
  };
};

/**
 * Clear all authentication data
 */
export const clearPartnerAuth = () => {
  localStorage.removeItem('partner_id');
  localStorage.removeItem('partner_name');
  localStorage.removeItem('authToken');
  localStorage.removeItem('isAuthenticated');
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user is authenticated
 */
export const isAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === 'true' && 
         localStorage.getItem('partner_id') !== null;
};
